import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

import { SnapshotAlarm, CreateSnapshotAlarmDto } from 'types';

export const createAlarm = ({
  data,
}: {
  data: CreateSnapshotAlarmDto;
}): Promise<SnapshotAlarm> => {
  return axios.post('/api/snapshots/alarms', data);
};

type UseCreateAlarmOptions = {
  config?: MutationConfig<typeof createAlarm>;
};

export const useCreateAlarm = ({ config }: UseCreateAlarmOptions = {}) => {
  return useMutation({
    onMutate: async (newAlarm) => {
      await queryClient.cancelQueries(['alarms']);

      const previousAlarms = queryClient.getQueryData<SnapshotAlarm[]>([
        'alarms',
      ]);

      queryClient.setQueryData(
        ['alarms'],
        [...(previousAlarms || []), newAlarm.data]
      );

      return { previousAlarms };
    },
    onError: (_, __, context: any) => {
      if (context?.previousAlarms) {
        queryClient.setQueryData(['alarms'], context.previousAlarms);
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['alarms']);
    },
    ...config,
    mutationFn: createAlarm,
  });
};
